import { render, staticRenderFns } from "./furniture.vue?vue&type=template&id=2ed1797c&"
import script from "./furniture.vue?vue&type=script&lang=js&"
export * from "./furniture.vue?vue&type=script&lang=js&"
import style0 from "./furniture.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports